import { configRefs } from '@utils/constants';

const promises = /* @__PURE__ */ new Map();
function loadScript(src) {
  let promise = promises.get(src);
  if (promise) {
    return promise;
  }
  promise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    script.onload = () => {
      resolve();
    };
    script.onerror = script.onabort = () => {
      promises.delete(src);
      reject();
    };
    document.head.appendChild(script);
  });
  promises.set(src, promise);
  return promise;
}
function loadStyle(src) {
  let promise = promises.get(src);
  if (promise) {
    return promise;
  }
  promise = new Promise((resolve, reject) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = src;
    link.onload = () => {
      resolve();
    };
    link.onerror = link.onabort = () => {
      promises.delete(src);
      reject();
    };
    document.head.appendChild(link);
  });
  promises.set(src, promise);
  return promise;
}
async function loadNotebookLibrary() {
  await loadScript(await configRefs.urls.gNotebook.get());
  if (typeof gNotebook !== "undefined") {
    return gNotebook;
  } else {
    throw new Error("Unable to load gNotebook script.");
  }
}
async function loadExportLibrary() {
  await loadScript(await configRefs.urls.gExport.get());
  if (typeof window.gExport !== "undefined") {
    return window.gExport;
  } else {
    throw new Error("Unable to load gExport script.");
  }
}
async function loadEditorLibrary() {
  await loadScript(await configRefs.urls.gEditor.get());
  if (typeof window.gEditor !== "undefined") {
    return window.gEditor;
  } else {
    throw new Error("Unable to load gEditor script.");
  }
}
async function loadPollyLibrary() {
  await loadScript(await configRefs.urls.gPolly.get());
  if (typeof window.gPolly !== "undefined") {
    return window.gPolly;
  } else {
    throw new Error("Unable to load gPolly script.");
  }
}

export { loadEditorLibrary, loadExportLibrary, loadNotebookLibrary, loadPollyLibrary, loadScript, loadStyle };
//# sourceMappingURL=dom.load-script.js.map
